module.exports = __webpack_public_path__ + "static/email-template-receipt-robolly-d27413c9cf9afc1f4751cc18549eb7fc.png";